export type SlVariant =
  | 'primary'
  | 'success'
  | 'neutral'
  | 'warning'
  | 'danger';
